// /web/src/pages/FAQ.jsx
import React from "react";

export default function FAQ() {
  return (
    <section className="wrap">
      <h1>FAQ</h1>

      <h3>What are tokens?</h3>
      <p>Tokens are usage credits. Each calculator run uses a small number of tokens. Your current balance appears on your Dashboard.</p>

      <h3>Is there a free trial?</h3>
      <p>Yes. New accounts start with free tokens so you can try the calculators without a card.</p>

      <h3>What happens when I run out?</h3>
      <p>You can upgrade anytime on the Pricing page. Plans include a monthly token allowance.</p>

      <h3>What data do you store?</h3>
      <p>Projects and calculator inputs you enter, plus usage events (date, calculator type, and a brief summary). We don’t store your card details; Stripe handles payments securely.</p>

      <h3>Is my data private?</h3>
      <p>Yes. We use Auth0 for authentication and industry-standard security. See our Privacy Policy for details.</p>

      <h3>Who can I contact?</h3>
      <p><a href="/contact">Contact us</a> or email <a href="mailto:hello@pebbledash.co">hello@pebbledash.co</a>.</p>
    </section>
  );
}
